module.exports = __webpack_public_path__ + "static/img/a7070xgri_pop10.865e86d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/nutrilite/a7070-glister/images/a7070xgri_pop10.jpg
// module id = Geq/
// module chunks = 0